import BsFileZone from './index.vue'
export default BsFileZone